import { render, staticRenderFns } from "./DequeueItem.vue?vue&type=template&id=20056cfc&scoped=true&"
import script from "./DequeueItem.vue?vue&type=script&lang=js&"
export * from "./DequeueItem.vue?vue&type=script&lang=js&"
import style0 from "./DequeueItem.vue?vue&type=style&index=0&id=20056cfc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20056cfc",
  null
  
)

export default component.exports